import { useId } from 'react';
import type { AiAccess } from '../ai/useAiAccess';
import { useT } from '../i18n/i18n';
import './aiCredits.css';

export default function AiCreditsBadge({ access }: { access: AiAccess | null }) {
  const t = useT();
  const tipId = useId();
  if (!access?.visible) return null;

  const developer = access.developer;
  const { available, monthlyLeft, topup } = access.balance;
  const label = developer ? t('AI unlimited') : t('{n} AI credits', { n: available.toLocaleString() });
  const tip = developer
    ? t('EasyLearning AI is unlimited for developers. Nothing is charged.')
    : t('EasyLearning AI credits you can use now: {monthly} left from this month\'s allowance and {bought} bought. Each request uses credits for what it actually costs.', {
      monthly: monthlyLeft.toLocaleString(),
      bought: topup.toLocaleString(),
    });

  return (
    <span className="ai-badge" tabIndex={0} aria-describedby={tipId}>
      {label}
      <span className="ai-badge-tip" role="tooltip" id={tipId}>{tip}</span>
    </span>
  );
}
